<template>
  <div class="input-file">
    <!--<div class="input-file__item-empty" @click="onChooseFileClick">-->
      <!--<span class="input-file__name input-file__name_empty ">Файл не выбран</span>-->
    <!--</div>-->
    <button class="gui-btn gui-btn--upload js-upload-file" @click.prevent="onChooseFileClick">Выберите файл</button>
    <!--<sign-file ref="select-file" @prepared="onSignaturePrepared"></sign-file>-->
  </div>
</template>

<script>
  //import SignFile from '@/components/sign-file/SignFile'

  export default {
    // components: {
    //   SignFile
    // },

    methods: {
      onChooseFileClick() {
        this.$refs['select-file'].open();
      },

      onSignaturePrepared(data) {
        this.$refs['select-file'].close();
        this.$emit('change', data);
      }
    }
  }
</script>

<style scoped>

</style>
